import React, { useContext, useReducer } from "react";

import { ReportState, ReportAction } from "./types";
import reducer from "./reducer";
import { initialState } from "./consts";

type Props = { children: React.ReactNode };

const ReportContext = React.createContext<{
  state: ReportState;
  dispatch: (action: ReportAction) => void;
}>({ state: initialState, dispatch: () => null });

export default function ReportStateProvider({ children }: Props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <ReportContext.Provider value={{ state, dispatch }}>
      {children}
    </ReportContext.Provider>
  );
}

export const useReportState = () => {
  return useContext(ReportContext).state;
};

export const useReportDispatch = () => {
  return useContext(ReportContext).dispatch;
};
